import Node from '~/scripts/services/model/node';

export default class KformTabRepreController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		this.kid = undefined;

		/** @type {?Node} */
		this.node = null;
	}

	$onInit() {
		this.node = new Node(this.$injector);
		if (this.form?.submission) {
			this.node.repre = this.form.submission.krepre;
		}
	}
}
